const COLORS = [
  'VS Code Dark',
  'VS Code Light',
  'Duotone Sea',
  'Atom Dark',
  "Synthwave '84",
]

export default COLORS;
